import React, { PropTypes } from 'react';
import { Resource, DownloadLink } from '../../components';

const MainResources = ({ assetsDownloadLink }) => (
  <div className="col-sm-12">
    <h2 className="resource-headline">Auth0 Logos</h2>
    <p className="resource-subheadline">
      Auth0’s blue logo works best on light backgrounds; the grey one is designed for dark backgrounds.
    </p>
    <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-blue-2b48b6384e.svg" alt="Auth0 Logo Blue" />
    <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-grey-eb7ddbce00.svg" alt="Auth0 Logo Grey" />
    <DownloadLink link={assetsDownloadLink} />
  </div>
);

MainResources.propTypes = {
  assetsDownloadLink: PropTypes.string.isRequired
};

export default MainResources;



// WEBPACK FOOTER //
// ./src/pages/press/components/MainResources/MainResources.js